import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Divider, useTheme, Button } from '@mui/material';
import SchoolIcon from '@mui/icons-material/School';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import GradeIcon from '@mui/icons-material/Grade';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { useMediaQuery } from '@mui/material';
import { Theme } from '@mui/material/styles';
import EastSharpIcon from '@mui/icons-material/EastSharp';
import WestSharpIcon from '@mui/icons-material/WestSharp';
import { buttonStyles } from '../utils/utils';

const Education: React.FC<{ isSidebarOpen: boolean; }> = ({ isSidebarOpen }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const theme2 = useTheme<Theme>(); // Get the theme and ensure it is of type Theme
  const isLargerThanSmall = useMediaQuery(theme2.breakpoints.up('sm'));
  const isLargerThanMedium = useMediaQuery(theme2.breakpoints.up('md'));
  const isLargerThanLarge = useMediaQuery(theme2.breakpoints.up('lg'));
  const isLargerThanExtraLarge = useMediaQuery(theme2.breakpoints.up('xl'));
  const educationDetails = [
    {
      degree: "Master's in Software Engineering",
      institution: 'Saint Louis University, St. Louis, MO, U.S.A',
      period: 'January 2023 - December 2024',
      cgpa: 'CGPA: 3.92/4',
    },
    // {
    //   degree: "Bachelor's in Electronics and Communications",
    //   institution:
    //     'G Pulla Reddy Engineering College, Kurnool, Andhra Pradesh, India',
    //   period: 'August 2016 - Apr 2020',
    //   cgpa: 'CGPA: 8.65/10',
    // },
    // {
    //   degree: 'Intermediate (Maths, Physics, Chemistry)',
    //   institution: 'Narayana Junior College, Kurnool, Andhra Pradesh, India',
    //   period: 'July 2014 - May 2016',
    //   cgpa: 'CGPA: 9.66/10',
    // },
    // {
    //   degree: '10th Class',
    //   institution: 'Rami Reddy High School',
    //   period: 'July 2007 - May 2014',
    //   cgpa: 'CGPA: 9.3/10',
    // },
  ];

  const handleNavigation = (path: string) => {
    navigate(path);
  };

  return (
    <Box
      sx={{
        // p: isLargerThanMedium ? 8 : 3,
        // pl: !isSidebarOpen ? 5 : (isLargerThanMedium ? 8 : 2),
        // pt: 10,
        // p: isLargerThanSmall ? (isLargerThanLarge ? 14 : 10) : 6,
        p: 4,
        pb: 8,
        pl: isLargerThanSmall ? (isLargerThanLarge ? (isLargerThanExtraLarge ? 14 : 10) : 8) : (isSidebarOpen? 3: 5),
        pr: isLargerThanSmall ? (isLargerThanLarge ? (isLargerThanExtraLarge ? 40 : 15) : 8) : 3,
        backgroundColor: 'rgb(255, 253, 231, 0.9)',
        width: '100%',
        overflowY: 'auto',
      }}
    >
      <Typography variant="h2" component="h2" sx={{ mb: 6, mt: 2, textAlign: 'center' }}>
        Education
      </Typography>
      {educationDetails.map((edu, index) => (
        <Box key={index} sx={{ marginBottom: 3 }}>
          <Typography variant="h5" gutterBottom>
            <SchoolIcon
              fontSize="large"
              color="action"
              sx={{ verticalAlign: 'middle', marginRight: 1 }}
            />
            {edu.degree}
          </Typography>
          <Box sx={{ marginLeft: isLargerThanMedium ? 4 : 2, }}>
            <Typography variant="body1" sx={{ fontWeight: '550' }}>
              <LocationOnIcon
                fontSize="small"
                color="action"
                sx={{
                  color: 'secondary.light',
                  verticalAlign: 'middle',
                  marginRight: 1,
                }}
              />
              {edu.institution}
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: '550' }}>
              <AccessTimeIcon
                fontSize="small"
                sx={{
                  color: 'secondary.light',
                  verticalAlign: 'middle',
                  marginRight: 1,
                }}
              />
              {edu.period}
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: '550' }}>
              <GradeIcon
                fontSize="small"
                color="action"
                sx={{
                  color: 'secondary.light',
                  verticalAlign: 'middle',
                  marginRight: 1,
                }}
              />
              {edu.cgpa}
            </Typography>
          </Box>
          {index !== educationDetails.length - 1 && (
            <Divider
              sx={{ my: 2, borderColor: theme.palette.secondary.light }}
            />
          )}
        </Box>
      ))}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 10, mb: 2 }}>
        <div>
          <Button
            sx={buttonStyles}
            variant="contained" color="primary" endIcon={<WestSharpIcon/>}
            onClick={() => handleNavigation('/')}>
            Profile
          </Button>
        </div>
        <div>
          <Button 
            sx={buttonStyles}
            variant="contained" color="primary" startIcon={<EastSharpIcon/>}
            onClick={() => handleNavigation('/academic-projects')}>
            {isLargerThanMedium ? 'Academic Projects' : 'Projects'}
          </Button>
          </div>
      </Box>
    </Box>
  );
};

export default Education;
